/**
 * Load File to Image
 * @param file
 * @returns Promise Image and data URL
 */
export const loadFileToImage = async file => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = e => {
            const image = new Image();
            image.onload = () => {
                resolve([image, e.target.result]);
            };
            image.onerror = () => {
                reject(new Error('Unable to load image'));
            };
            image.src = e.target.result;
        };
        fileReader.onerror = () => {
            reject(fileReader.error);
        };
    });
};

/**
 * Crop image to aspect ratio.
 * It crops out the central part of image.
 * @param image Image
 * @param width numerator of aspect ratio
 * @param height denominator of aspect ratio
 * @returns {HTMLCanvasElement}
 */
export const cropImageToAspectRatio = (image, width, height) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const imageRatio = image.width / image.height;
    const specsRatio = width / height;
    if (specsRatio < imageRatio) {
        const scaleY = image.height / height;
        const requiredWidth = width * scaleY;
        const extraWidth = image.width - requiredWidth;
        canvas.width = requiredWidth;
        canvas.height = image.height;
        ctx.drawImage(
            image,
            extraWidth / 2,
            0,
            requiredWidth,
            image.height,
            0,
            0,
            requiredWidth,
            image.height
        );
    } else if (specsRatio > imageRatio) {
        const scaleX = image.width / width;
        const requiredHeight = height * scaleX;
        const extraHeight = image.height - requiredHeight;
        canvas.width = image.width;
        canvas.height = requiredHeight;
        ctx.drawImage(
            image,
            0,
            extraHeight / 2,
            image.width,
            requiredHeight,
            0,
            0,
            image.width,
            requiredHeight
        );
    } else {
        ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, image.width, image.height);
    }

    return canvas;
};

/**
 * Draw an images on the canvas context
 * @param {string} context
 * @param {string} imageUrl
 * @return {Promise<unknown>}
 */
export const drawImage = async (context, imageUrl) => {
    const image = new Image();
    image.crossOrigin = 'Anonymous';
    image.src = imageUrl;
    return new Promise(resolve => {
        image.onload = () => {
            context.drawImage(image, 0, 0);
            resolve(image);
        };
    });
};
